import { Component, ViewEncapsulation, Input, Renderer2 } from '@angular/core';
import { NgxDocViewerModule, ViewerType } from 'ngx-doc-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import {
  FileContentModel,
  PreviewFileTypes
} from '../../../models/file-content.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';

@Component({
  selector: 'app-preview-file',
  templateUrl: './preview-file.component.html',
  styleUrls: ['./preview-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgxDocViewerModule, PdfViewerModule]
})
export class PreviewFileComponent {
  @Input() fileContentModel!: FileContentModel;
  @Input() engagementPreviewInput!: EngagementPreviewInput;
  viewerName: ViewerType = 'office';

  constructor(private renderer: Renderer2) {}

  checkIsImage(fileType: number): boolean {
    return fileType === PreviewFileTypes.image;
  }

  checkIsPdf(fileType: number) {
    return fileType === PreviewFileTypes.pdf;
  }

  checkIsDoc(fileType: number): boolean {
    return (
      fileType === PreviewFileTypes.doc || fileType === PreviewFileTypes.ppt
    );
  }

  get isCustomerSurvey(): boolean {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.customerSurvey
    );
  }

  get isPartnerSurvey(): boolean {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.partnerSurvey
    );
  }

  checkIsUnSupportedFileType(fileType: number): boolean {
    return fileType === PreviewFileTypes.unsupported;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  open(): void {}

  close(): void {
    this.fileContentModel = {
      fileUrl: '',
      previewFileType: 0,
      fileFound: false
    };
  }

  afterPdfLoadComplete(pdfData: any): void {
    const totalPages = pdfData.numPages;
    const pdfElement = this.renderer.selectRootElement('#pdfViewer', true);
    if (pdfElement) {
      this.renderer.setStyle(pdfElement, 'height', `${totalPages * 1025}px`);
    }
  }
}
